<template>

    <div class="vol">
        <div class="btn-cont">
            <a href="#" @click.prevent="toggleMute()">
                <icon v-if="isMuted" icon="volume-mute"/>
                <icon v-else icon="volume-up"/>
            </a>
        </div>
        <div class="bar-cont">
            <div class="prog-bar" ref="outer" @click.prevent="setPosition($event)">
                <div class="bar bar-outer">
                    <div class="bar bar-inner" ref="progbar" :style="{width: progress}"></div>
                    <div class="pointer" :style="{left:mousePos}"></div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>

    import Icon from "../ui/Icon";

    export default {
        name: 'VolumeControl',
        props: ['me', 'isMobile'],
        data() {
            return {
                muted: true,
                position: 0,
                mpos: 50
            }
        },
        computed:{
            progress(){
                return this.position+"%"
            },
            isMuted(){
                return this.muted || this.position==0;
            },
            mousePos(){
                return this.mpos+"px";
            }
        },
        watch: {
          me(newVal, oldVal) {
            if(oldVal === false && newVal) this.init();
          }
        },
        mounted() {
            setTimeout(()=>{
                if(this.me) this.init();
            },5);
        },
        methods: {
            init() {
              this.muted  = (localStorage.getItem('player.muted') == "false" ) ? false : true;
              let volume = parseFloat(localStorage.getItem('player.volume'));
              if(!volume) volume = .75;

              this.me.muted  = this.muted;
              if(!this.isMobile) this.me.volume = volume;
              this.position  = this.me.volume * 100;
              this.me.onvolumechange = (e)=>{this.calcProg()};
              this.$refs['outer'].onmousemove = (e)=>{this.mpos = this.getXpos(e)};
            },
            calcProg(){
                this.position = this.me.volume * 100;
                this.muted    = this.me.muted;
            },
            setPosition(event){
                const pos  = this.getXpos(event);
                const perc = pos /  this.$refs['outer'].offsetWidth;
                this.me.volume = perc;
                localStorage.setItem('player.volume', this.me.volume)
                if(this.me.muted){
                    this.toggleMute();
                }
            },
            toggleMute(){
                this.me.muted = !this.me.muted;
                localStorage.setItem('player.muted', this.me.muted)

            },
            getXpos(event){
                return event.clientX - this.$refs['outer'].offsetLeft;
            }

        },
        components:{
            Icon
        }
    }
</script>

<style lang="sass" scoped>
    .vol
        display: table

    .btn-cont, .bar-cont
        display: table-cell

    .btn-cont
        padding-right: 10px

    .prog-bar
        width: 100px

</style>



// WEBPACK FOOTER //
// src/components/player/VolumeControl.vue